<template>
  <div class="upsell-takeover" data-testid="upsell-takeover">
    <div
      class="upsell-takeover__content mx-auto flex w-full flex-col gap-10 p-6 lg:pt-[60px] lg:pb-12"
    >
      <div class="upsell-takeover__top">
        <UpsellHero
          :title="title"
          :description="description"
          :price="price"
          @chat="emit('chat')"
          @upgrade="emit('upgrade')"
        />
        <UpsellFeatures :features="features" />
      </div>
      <PlanComparisonTable
        class="mt-10"
        :caption="tableCaption"
        :plans="plans"
        :sections="sections"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useMaxUpsellContent } from '../composables/useMaxUpsellContent'

import PlanComparisonTable from './PlanComparisonTable.vue'
import UpsellFeatures from './UpsellFeatures.vue'
import UpsellHero from './UpsellHero.vue'

const emit = defineEmits<{
  chat: []
  upgrade: []
}>()

const { description, features, plans, price, sections, tableCaption, title } =
  useMaxUpsellContent()
</script>

<style lang="scss" scoped>
// Full-bleed page background matching the sidebar, with the content column
// centered on top — cards and CTAs sit white-on-gray per the design.
.upsell-takeover {
  min-height: 100%;
  background-color: var(--background-secondary);

  // 854px design frame + 24px side padding on each side.
  &__content {
    max-width: 902px;
  }

  &__top {
    display: grid;
    gap: 24px;
    align-items: stretch;

    @media (min-width: 1024px) {
      grid-template-columns: 336px minmax(0, 1fr);
    }
  }
}
</style>
